import { BaseApi } from './base.api.js';

export class AssetGroupApi extends BaseApi {
    constructor(client) {
        super(client, '/asset-group');
    }
}
